export default __webpack_public_path__ + "e46177b21b27cd6643c5e35f7262b3e0.woff2";